import { Directive, ElementRef, HostListener, Input, Renderer2 } from '@angular/core';

@Directive({
  selector: '[numbersOnly]'
})
export class NumberDirective {
  @Input() allowDecimal: boolean = false;

  constructor(private elementRef: ElementRef, private renderer: Renderer2) {}

  @HostListener('input', ['$event']) onInputChange(event: any): void {
    const inputElement = this.elementRef.nativeElement;
    let initialValue = inputElement.value;
    let cursorPosition = inputElement.selectionStart || 0;

    if (!this.allowDecimal) {
      initialValue = initialValue.replace(/\./g, '');
    }

    let newValue = initialValue.replace(/[^0-9.]/g, '');

    if (this.allowDecimal) {
      const parts = newValue.split('.');
      if (parts.length > 2) {
        newValue = parts[0] + '.' + parts.slice(1).join('');
      }
    }

    if (!this.allowDecimal) {
      newValue = newValue.replace(/\./g, '');
    }

    if (initialValue !== newValue) {
      this.renderer.setProperty(inputElement, 'value', newValue);

      const removedChars = initialValue.length - newValue.length;
      cursorPosition = Math.max(cursorPosition - removedChars, 0);
      inputElement.setSelectionRange(cursorPosition, cursorPosition);

      event.stopPropagation();
    }
  }

  @HostListener('keydown', ['$event']) onKeyDown(event: KeyboardEvent): void {
    if (!this.allowDecimal && event.key === '.') {
      event.preventDefault();
    }

    if (event.key === '-' || event.key.toLocaleLowerCase() === 'e') {
      event.preventDefault();
    }

    const inputElement = this.elementRef.nativeElement;
    if (this.allowDecimal && event.key === '.' && inputElement.value.includes('.')) {
      event.preventDefault();
    }
  }
}
